import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Dropdown from 'react-bootstrap/Dropdown';
import { Scrollbars } from 'react-custom-scrollbars';
import '../../../../../../assets/stylesheets/CategoryView.scss';
import imageContainer from '../../../../../../helpers/imageContainer';

const CategoryViewNavigation = function ({
  providers,
  provider,
  gameTags,
  selectedGameTag,
  search,
  setSearch,
  onSearchChange,
  onProviderChange,
  onGameTagChange,
}) {
  const { t } = useTranslation();
  const {game} = useParams();
  const [showContent, setShowContent] = useState(false);
  const onSetShowContent = useCallback((e) => {
    setShowContent(!showContent);
  },[showContent, setShowContent]);

  useEffect(() => {
    setSearch('');
  }, [game]);

  return (
    <div className="category-nav">
      <Dropdown className="category-nav__providers__dropdown" onClick={() => onSetShowContent()}>
        <Dropdown.Menu className="category-nav__providers__menu full-width" flip={false}>
        <div className={`category-nav__search`}>
          <input value={search}  className={``} onChange={onSearchChange} />
          <span className={'search-icon'}></span>
        </div>
          <Scrollbars universal className="category-nav__providers__scrollarea">
            {providers.map((p, index) => (
              <div className={`game-item-wrapper ${(p === provider) ? 'selected' : ''}`} key={index}>
                <Dropdown.Item
                  key={index}
                  onClick={() => onProviderChange(p)}
                  className={"category-nav__providers__option"}
                >
                  {p === "all" ? <span>{t(p)}</span> : <img src={imageContainer[p.split(' ').join('').replace("'", '').toLowerCase()]} alt={p} />}
                </Dropdown.Item>
              </div>
            ))}
          </Scrollbars>
        </Dropdown.Menu>
        <Dropdown.Toggle className="category-nav__providers__select" bsPrefix="dropdown-toggle-custom">
          <div className="category-nav__providers__container">
            <div className="category-nav__providers__container-filter-name">{t('filter')}: {provider  === 'all' ? t(provider): provider}</div>
            <i className={`fa ${showContent ? 'fa-angle-up' : 'fa-angle-down'} category-nav__dropdown__icon`} />
          </div>
        </Dropdown.Toggle>
      </Dropdown>
    </div>
  );
};

export default CategoryViewNavigation;
